import React from 'react';
import { generatePath } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { API_PLATFORM_VERSION_ITEM } from '../constants';
import { PlatformVersionItem } from '../types';

type Props = {
  item: PlatformVersionItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function DeletePlatformVersionModal({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { id, edgeComponentName } = item || {};
  const [handleSubmit, loading] = useStatefulApi(
    () =>
      pepApiRequest({
        method: RequestMethod.Delete,
        url: generatePath(API_PLATFORM_VERSION_ITEM, { id }),
        useProxy: false,
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: `${edgeComponentName} is deleted`,
        text: 'Platform version has been successfully deleted.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <ModalDialog
      open={open}
      title="Remove platform version"
      text={`Are you sure you want to remove "${edgeComponentName}"?`}
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      cancelBtnText="No"
      confirmBtnText="Yes"
    />
  );
}

export default DeletePlatformVersionModal;
